export const forums = {
  forumsSearchInputPlaceholder: 'Pesquisar',
  forumsFollowDiscussionButtonTitle: 'Seguir',
  forumsFollowingDiscussButtonTitle: 'Seguindo',
  forumDiscussionInfoNoReplyText: 'Sem respostas ainda',
  forumsDiscussionDetailsStartButtonTitle: 'Iniciar discussão',
  forumDetailsCreatedByText: 'por',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Copiar link',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Denunciar conteúdo',
  forumsReportedCurtainContent: 'Conteúdo denunciado',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link copiado!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Fixar discussão',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Desafixar discussão',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Editar discussão',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Excluir discussão',
  forumsDiscussionDetailspPopupDeleteTitle: 'Excluir',
  forumsDiscussionDetailspPopupDeleteText: 'Deseja realmente excluir esta discussão?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Cancelar',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Confirmar',
  forumsDiscussionDetailsDeleledAlertText: 'Discussão excluída!',
  forumsNewDiscussionTitle: 'Nova discussão',
  forumsNewDiscussionTitlePlaceholder: 'Título...',
  forumsNewDiscussionBodyPlaceholderText: 'Digite seu texto aqui...',
  forumsNewDiscussionPublishButtonTitle: 'Publicar',
  forumsNewDiscussionLocationCurtainTitle: 'Localização',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Nome da localização',
  forumsNewDiscussionEditLocationCurtainText: 'Editar localização',
  forumsNewDiscussionDeleteLocationCurtainText: 'Excluir localização',
  forumsNewDiscussionCreatePollTitle: 'Criar enquete',
  forumsNewDiscussionTitleInputPlaceholder: 'Título',
  forumsNewDiscussionOptionInputPlaceholder: 'Opção',
  forumsNewDiscussionAddButtonTitle: 'Adicionar opção',
  forumsNewDiscussionCreateButtonTitle: 'Criar',
  forumsNewDiscussionPollTitleBlankAlertText: 'O título não pode ficar em branco!',
  forumsNewDiscussionPollOptionBlankAlertText: 'A opção não pode ficar em branco!',
  forumsNewDiscussionPollLongTitleAlertText: 'O título deve ter no máximo 140 caracteres',
  forumsNewDiscussionPollLongOptionAlertText: 'A opção deve ter no máximo 50 caracteres',
  forumsNewDiscussionEditPollIconText: 'Editar enquete',
  forumsNewDiscussionRemovePollIconText: 'Remover enquete',
  forumsDiscardDraftPopupTitle: 'Rascunho',
  forumsDiscardDraftPopupText: 'Deseja descartar este rascunho?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Cancelar',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Confirmar',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Responder',
  forumsDiscussionDetailsNoCommentsText: 'Ainda não há comentários\nVocê pode ser o primeiro a comentar',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Responder',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Copiar link',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link copiado!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Denunciar conteúdo',
  forumsDiscussionDetailsPostCurtainReportedText: 'Conteúdo denunciado',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Responder',
  forumsEditDiscussionTitle: 'Editar discussão',
  forumsEditDiscussionSaveButtonTitle: 'Salvar',
  forumsEditedDiscussionSavedAlertText: 'Discussão salva!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Editar resposta',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Excluir resposta',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Comentário salvo!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Comentário excluído!',
  forumsAlertSomethinWrong: 'Algo deu errado!',
  forumsMaxMbSize: 'Você só pode enviar até {size} MB de uma vez',
  forumsMaxAttachments: 'Você excedeu o número máximo de anexos. O máximo de anexos é {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Excluir',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Deseja realmente excluir este comentário?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Denunciar conteúdo',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Conteúdo denunciado',
  forumDiscussionInfoLastReplyText: 'Última resposta',
  forumsDiscussionAt: 'em',
  forumsDiscussionDetailsFlagCurtainTitle: 'Denunciar conteúdo',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Conteúdo denunciado',
  forumsPollInfoVotesText: 'votos',
  forumsPollInfoEditVoteText: 'Editar voto',
  forumsPollFinishPollText: 'Encerrar enquete',
  forumsPollFinishedPollText: 'Encerrada',
  forumsPollInProgresslText: 'Em andamento',
  forumsPollCurtainTitle: 'Encerrar enquete',
  forumsPollCurtainText: 'Os usuários não poderão votar após o encerramento da enquete.',
  forumsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  forumsPollInfoPollVotesCurtainTitle: 'Votos na enquete'
}
